import { makeAutoObservable } from 'mobx';
import { pick } from 'lodash-es';
import type { Filter } from 'ksnm-common-ui/lib/Table2/utils/TableRequest';

import { cmApi } from '@src/api';
import type { CmApi } from '@src/api';

import { preloaderStore } from '../preloaderStore';

export interface PagesParamInterface {
  typeForm?: 'level1' | 'level2' | 'level3' | 'level4' | 'level5' | 'level6' | 'level7' | 'controlRatio' | string;
  reportVersionCode?: string;
  reportPackageCode?: string;
  reportSettingsTableSource?: string;
  reportFilters?: Filter[][];
  reportSettingsUITableSource?: string;
  organizationCode?: string;
  title?: string;
  parentCode?: string;
  hideTransactions?: boolean;
  rounded?: boolean;
  reportGroupCode?: string;
}

class ReportingFormsStore {
  pagesParam: PagesParamInterface[] = [];

  breadcrumbs: string[] = [];

  fullSizeInfo = false;

  api: CmApi;

  constructor({ api }: { api: CmApi }) {
    this.api = api;
    makeAutoObservable(this);
  }

  get lastPagesParam() {
    return this.pagesParam[this.pagesParam.length - 1] ?? {};
  }

  setFullSizeInfo = (info: boolean) => {
    this.fullSizeInfo = info;
  };

  addBreadcrumbs = (breadcrumbs: string[], all = false) => {
    if (all) {
      this.breadcrumbs = [...breadcrumbs];
    } else {
      this.breadcrumbs = [...this.breadcrumbs, ...breadcrumbs];
    }
  };

  removeBreadcrumb = (count = 1) => {
    this.breadcrumbs = [...this.breadcrumbs.slice(0, -count)];
  };

  addPage = (params: PagesParamInterface[], all = false) => {
    if (all) {
      this.pagesParam = [...params];
    } else {
      this.pagesParam = [...this.pagesParam, ...params];
    }
  };

  removePage = (all = false, count = 1) => {
    if (all) {
      this.pagesParam = [];
    } else {
      this.pagesParam = [...this.pagesParam.slice(0, -count)];
    }
  };

  getReportSettings = async <T>(organizationCode: string, disclosureReportVersionCode: string, context: T) => {
    preloaderStore.preloader(true);

    const { data: reportSettings } = await this.api.reportSettings.getReportSetting(
      organizationCode,
      disclosureReportVersionCode,
    );

    preloaderStore.preloader(false);

    if (reportSettings) {
      const params = ['urlP1', 'urlP2', 'urlP3', 'urlP4', 'urlP5', 'urlP6', 'urlP7', 'urlP8', 'urlP9'];
      const paramsValue = Object.values(pick(reportSettings, params)).filter((value) => value);
      let valueParametersFromContext = paramsValue.length ? pick(context, paramsValue as string[]) : {};

      // в urlP10 могут приходить параметры в виде 'property=value;'
      if (reportSettings.urlP10) {
        let extraParameters = {};
        reportSettings.urlP10
          .split(';')
          .filter((item) => !!item)
          .forEach((item) => {
            const property = item.split('=')[0];
            const value = item.split('=')[1];
            extraParameters = { ...extraParameters, [property]: value };
          });

        valueParametersFromContext = { ...valueParametersFromContext, ...extraParameters };
      }

      return { reportSettings, valueParametersFromContext };
    }
    return {};
  };
}

export const reportingFormsStore = new ReportingFormsStore({ api: cmApi });
